import React from 'react';
import { Button } from 'devextreme-react';
import { NotificationModal } from '../../components/notifications';
import { usePushNotificationContext } from '../../contexts/pushNotifications';

const NotificationTestPage = () => {
  const { 
    pushToken, 
    isInitialized, 
    sendTokenToServer,
    showNotificationAlert 
  } = usePushNotificationContext();

  // Test-Benachrichtigung erstellen
  const createTestNotification = () => {
    const testNotification = {
      id: `test-${Date.now()}`,
      title: 'Test Benachrichtigung',
      body: 'Dies ist eine Test-Benachrichtigung für SwimPilot',
      data: {
        type: 'test',
        timestamp: new Date().toISOString()
      },
      date: new Date().toISOString(),
      read: false
    };

    showNotificationAlert(testNotification);
  };

  const handleSendTokenToServer = () => {
    if (pushToken) {
      sendTokenToServer(pushToken, 'test-user-id');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Push Benachrichtigungen - Test</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Status</h3>
        <p>Initialisiert: {isInitialized ? 'Ja' : 'Nein'}</p>
        <p>Push Token: {pushToken ? 'Erhalten' : 'Nicht verfügbar'}</p>
        {pushToken && (
          <div style={{ marginTop: '10px' }}>
            <strong>Token:</strong>
            <div style={{ 
              background: '#f5f5f5', 
              padding: '10px', 
              borderRadius: '4px', 
              fontSize: '12px', 
              wordBreak: 'break-all',
              marginTop: '5px'
            }}>
              {pushToken}
            </div>
          </div>
        )}
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Aktionen</h3>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <Button
            text="Test-Benachrichtigung erstellen"
            type="default"
            onClick={createTestNotification}
          />
          
          <Button
            text="Token an Server senden"
            type="normal"
            onClick={handleSendTokenToServer}
            disabled={!pushToken}
          />
        </div>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Benachrichtigungen</h3>
        <NotificationModal />
      </div>

      <div style={{ marginTop: '30px', padding: '15px', background: '#e3f2fd', borderRadius: '8px' }}>
        <h4>Hinweise zur Verwendung:</h4>
        <ul>
          <li>Push-Benachrichtigungen funktionieren nur auf nativen Plattformen (iOS/Android)</li>
          <li>Im Browser werden keine echten Push-Benachrichtigungen unterstützt</li>
          <li>Sie können Test-Benachrichtigungen erstellen, um die UI zu testen</li>
          <li>Der Push Token muss an Ihren Backend-Server gesendet werden</li>
          <li>Für echte Push-Benachrichtigungen benötigen Sie Firebase (Android) und APNs (iOS)</li>
        </ul>
      </div>
    </div>
  );
};

export default NotificationTestPage;
